import { Grid2 as Grid, Box, Tabs, Tab } from "@mui/material";

import { ConditionalGrid } from "@shared/components";
import {
  AcessControlFields,
  BasicInformationFields,
  CustomizationFields,
  ModulesFields,
  SuperAppModule,
  ReferralProgramFields,
  IntegrationFields,
  TermsAndPolicyFields,
  AgreementProductsModule,
  TiledeskFields,
  FinancialVolumetryFields,
} from "./fields";

import { useAgreementForm } from "./controller";
import { useParams } from "react-router";
import { PlansDefaultModule } from "./fields/PlansDefault";

export function AgreementForm() {
  const { id } = useParams();
  const { selectedTable, translate, handleChange } = useAgreementForm();

  return (
    <Box
      component="form"
      sx={{ display: "flex", flexDirection: "column" }}
      autoComplete="off"
    >
      <Grid container spacing={4}>
        <Grid size={{ xs: 12 }}>
          <Tabs
            value={selectedTable}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab
              label={translate("v1/agreement_admin.sections.general_settings")}
            />
            <Tab label={translate("v1/agreement_admin.sections.financial")} />
            <Tab label={translate("v1/agreement_admin.sections.modules")} />
            {/* <Tab
              label={translate("v1/agreement_admin.sections.super_app_modules")}
              disabled={!id}
            /> 
            <Tab
              label={translate("v1/agreement_admin.sections.plans_default")}
              disabled={!id}
            />*/}
            <Tab
              label={translate("v1/agreement_admin.sections.products")}
              disabled={!id}
            />
            <Tab label={translate("v1/agreement_admin.sections.customization")} />
            <Tab
              label={translate("v1/agreement_admin.sections.referral_program")}
            />
            <Tab
              label={translate("v1/agreement_admin.sections.external_connections")}
            />
            <Tab
              label={translate("v1/agreement_admin.sections.terms_and_policy")}
            />
            <Tab
              label={translate("tiledesk.sections.title")}
              disabled={!id}
            />
          </Tabs>
        </Grid>

        <ConditionalGrid container spacing={2} isVisible={selectedTable === 0}>
          <Grid size={{ xs: 12 }}>
            <BasicInformationFields />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <AcessControlFields />
          </Grid>
        </ConditionalGrid>

        <ConditionalGrid container spacing={2} isVisible={selectedTable === 1}>
          <FinancialVolumetryFields />
        </ConditionalGrid>

        <ConditionalGrid container spacing={2} isVisible={selectedTable === 2}>
          <ModulesFields />
        </ConditionalGrid> 
 
       {/*  <ConditionalGrid container spacing={2} isVisible={selectedTable === 2}>
          <SuperAppModule />
        </ConditionalGrid>

        <ConditionalGrid container spacing={2} isVisible={selectedTable === 3}>
          <PlansDefaultModule />
        </ConditionalGrid> */}

        <ConditionalGrid container spacing={2} isVisible={selectedTable === 3}>
          <AgreementProductsModule />
        </ConditionalGrid>

        <ConditionalGrid isVisible={selectedTable === 4}>
          <CustomizationFields />
        </ConditionalGrid>

        <ConditionalGrid isVisible={selectedTable === 5}>
          <ReferralProgramFields />
        </ConditionalGrid>

        <ConditionalGrid isVisible={selectedTable === 6}>
          <IntegrationFields />
        </ConditionalGrid>

        <ConditionalGrid isVisible={selectedTable === 7}>
          <TermsAndPolicyFields />
        </ConditionalGrid>

        <ConditionalGrid isVisible={selectedTable === 8}>
          <TiledeskFields />
        </ConditionalGrid>
      </Grid>
    </Box>
  );
}
